// How a screen names one 529 withdrawal in a sentence. (ZEN-785)
import { fmtDate } from "@/lib/format";

/** "received 15/Apr/2026", or "requested …" when the money has not arrived. */
export function withdrawalWhen(w) {
  if (w?.date_received) return `received ${fmtDate(w.date_received)}`;
  if (w?.date_requested) return `requested ${fmtDate(w.date_requested)}`;
  return null;
}

/** "the withdrawal received 15/Apr/2026". */
export function withdrawalPhrase(w) {
  const when = withdrawalWhen(w);
  return when ? `the withdrawal ${when}` : "a withdrawal with no date";
}
